export default {"src":"/_next/static/media/DocumentGenerateIcon.1bb9717d.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};